import { mediaUrl } from "@/lib/api";

const initials = (name) =>
  (name || "?")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() || "")
    .join("") || "?";

// Deterministic soft background from the name so initials avatars aren't all identical.
const palette = [
  "bg-orange-100 text-orange-700", "bg-blue-100 text-blue-700", "bg-emerald-100 text-emerald-700",
  "bg-violet-100 text-violet-700", "bg-rose-100 text-rose-700", "bg-cyan-100 text-cyan-700",
  "bg-amber-100 text-amber-700", "bg-indigo-100 text-indigo-700",
];
const tone = (name) => {
  let h = 0;
  for (const c of name || "") h = (h * 31 + c.charCodeAt(0)) % palette.length;
  return palette[h];
};

export function GuestAvatar({ src, name, className = "", textClassName = "text-sm font-semibold" }) {
  if (src) {
    return <img src={mediaUrl(src)} alt={name || ""} className={`object-cover ${className}`} />;
  }
  return (
    <div className={`flex items-center justify-center ${tone(name)} ${className}`}>
      <span className={textClassName}>{initials(name)}</span>
    </div>
  );
}
